var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ]
    },
    [
      _c(
        "el-dialog",
        {
          staticClass: "package-box",
          staticStyle: { "padding-top": "0" },
          attrs: {
            visible: _vm.showDialog,
            "before-close": _vm.onCloseDialog,
            "close-on-click-modal": false
          }
        },
        [
          _c("div", { staticClass: "work-title" }, [
            _c("h3", { staticStyle: { margin: "0" } }, [
              _vm._v("\n        工单：" + _vm._s(_vm.work_id) + "\n        "),
              _vm.is_son_order
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#f00",
                        "background-color": "yellow"
                      }
                    },
                    [_vm._v("(子工单)")]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "header-box" }, [_vm._v("拆包信息")]),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "寄回运单号：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.work.back_shipping_num,
                      callback: function($$v) {
                        _vm.$set(_vm.work, "back_shipping_num", $$v)
                      },
                      expression: "work.back_shipping_num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "商品名称:" } }, [
                _vm._v("\n        " + _vm._s(_vm.work.goods_name) + "\n      ")
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "商品图片：" } }, [
                _c("div", { staticStyle: { width: "50px", height: "50px" } }, [
                  _c("img", {
                    staticStyle: { height: "100%", width: "100%" },
                    attrs: { src: _vm.work.main_img },
                    on: {
                      click: function($event) {
                        return _vm.imgClick(_vm.work.middle_img)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { label: "用户上传图片：" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "50px", height: "50px" } },
                    [
                      _c("img", {
                        directives: [{ name: "viewer", rawName: "v-viewer" }],
                        staticStyle: { height: "100%", width: "100%" },
                        attrs: { src: _vm.work.picture }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "颜色-尺码：" } }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.work.co_val + "-" + _vm.work.si_val))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "问题类型:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.problemChange },
                      model: {
                        value: _vm.model.id,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "id", $$v)
                        },
                        expression: "model.id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.problem, function(item) {
                        return _c("el-option", {
                          key: item.problem_id,
                          attrs: {
                            value: item.problem_id,
                            label: item.problem_name
                          }
                        })
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.model.sub_id,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "sub_id", $$v)
                        },
                        expression: "model.sub_id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.subPorblem, function(item) {
                        return _c("el-option", {
                          key: item.problem_id,
                          attrs: {
                            value: item.problem_id,
                            label: item.problem_name
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "待拆包件数：" } }, [
                _c("div", [_vm._v(_vm._s(_vm.work.num))])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登记类型：" } },
                [
                  _vm.blp_type.length > 0
                    ? _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", size: "mini" },
                          model: {
                            value: _vm.value,
                            callback: function($$v) {
                              _vm.value = $$v
                            },
                            expression: "value"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "正常", value: 0 }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.blp_type, function(item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: { label: item.label, value: item.key }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-plus",
                    staticStyle: {
                      "margin-left": "10px",
                      height: "40px",
                      width: "40px",
                      cursor: "pointer"
                    },
                    on: { click: _vm.addBlp }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "80%" },
                      attrs: { data: _vm.data }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "blp_type_index", label: "类型" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "blp-text" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getBlpText(scope.row.blp_type)
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "num", label: "数量", width: "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input-number", {
                                  attrs: {
                                    min: _vm.min,
                                    max: Number(_vm.work.num),
                                    size: "mini"
                                  },
                                  model: {
                                    value: scope.row.num,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "num", $$v)
                                    },
                                    expression: "scope.row.num"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "blp_note",
                          label: "备注",
                          width: "150"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请输入内容"
                                  },
                                  model: {
                                    value: scope.row.blp_note,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "blp_note", $$v)
                                    },
                                    expression: "scope.row.blp_note"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "blp-img-up", label: "图片" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !scope.row.blp_img
                                  ? _c(
                                      "div",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.setIndex(scope.$index)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "“upload”",
                                            attrs: {
                                              action: _vm.action,
                                              "on-success": _vm.handleSuccess,
                                              "with-credentials": ""
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-picture",
                                              staticStyle: {
                                                "font-size": "20px"
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.blp_img
                                  ? _c("img", {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" }
                                      ],
                                      staticClass: "avatar",
                                      staticStyle: {
                                        width: "30px",
                                        height: "30px"
                                      },
                                      attrs: { src: scope.row.blp_img }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "删除" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "blp-op" }, [
                                  _c("i", {
                                    staticClass: "el-icon-delete",
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "font-size": "20px"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteItem(scope.$index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.work.handle_type == 1
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "header-box" }, [
                    _vm._v("\n        收件人信息"),
                    _c(
                      "span",
                      { staticStyle: { "font-size": "14px", color: "red" } },
                      [_vm._v("（如不填写，默认为原订单收件人地址）")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.form, "label-width": "120px" }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "寄出地址：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { size: "mini", placeholder: "省" },
                              on: { change: _vm.getCity },
                              model: {
                                value: _vm.form.province,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "province", $$v)
                                },
                                expression: "form.province"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: 0 }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.province, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { size: "mini", placeholder: "市" },
                              on: { change: _vm.getDistrict },
                              model: {
                                value: _vm.form.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "city", $$v)
                                },
                                expression: "form.city"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: 0 }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.city, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { size: "mini", placeholder: "区/县" },
                              model: {
                                value: _vm.form.district,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "district", $$v)
                                },
                                expression: "form.district"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: 0 }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.district, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "地址", size: "mini" },
                            model: {
                              value: _vm.form.address,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "address", $$v)
                              },
                              expression: "form.address"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收件人姓名：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "收件人姓名", size: "mini" },
                            model: {
                              value: _vm.form.consignee,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consignee", $$v)
                              },
                              expression: "form.consignee"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收件人电话：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "收件人电话", size: "mini" },
                            model: {
                              value: _vm.form.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mobile", $$v)
                              },
                              expression: "form.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onCloseDialog } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitData } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showImg
        ? _c("preview-image", {
            attrs: { imgs: _vm.imgs, show: _vm.showImg },
            on: { closeBox: _vm.closeImg }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.full_screenAlert_Show,
            fullscreen: true,
            "append-to-body": true,
            "show-close": false,
            center: true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "30vh",
            "custom-class": "_un_pack_full_screen_alert"
          },
          on: {
            "update:visible": function($event) {
              _vm.full_screenAlert_Show = $event
            }
          }
        },
        [
          _vm.fullScreenAlertText.part_suit
            ? _c("p", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.fullScreenAlertText.part_suit) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "_special_text_div",
            staticStyle: { "margin-bottom": "5vh" },
            domProps: { innerHTML: _vm._s(_vm.fullScreenAlertText.text) }
          }),
          _vm._v(" "),
          _c("p", [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(_vm._s(_vm.fullScreenAlertText.time) + "秒后关闭")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e1160fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e1160fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/components/UnPackage.vue
// module id = null
// module chunks = 